import { createSlice } from '@reduxjs/toolkit';
import * as Seters from './seters';
import { IAdress, IPersonalInfo } from '../../../models/PersonalInfo';
import { IConsentObject } from '../../../models/ConsentObject';

export interface State {
	personalInfo: IPersonalInfo;
	personalInfoErrors: PersonalInfoErrors;
	personalInfoRAdressErrors: PersonalInfoAdressErrors;
	startDate: string | null;
	consentsStep1: IConsentObject[];
	consentsStep2: IConsentObject[];
	selectedRisksIds: number[];
	vereficationCode: string;
	paywallUrl: string | null;
	vereficationCodeError: string;
	loaded: boolean;
	formAccessible: boolean;
	extendedOcCoverageSelected: boolean;
	formSuccess: boolean;
	showStage1Error: boolean;
	showStage2Error: boolean;
	hasBusiness: boolean;
}

export const defaultPersonalInfo: IPersonalInfo = {
	email: null,
	firstName: null,
	lastName: null,
	pesel: null,
	phone: null,
	residentalAddress: null,
	businessName: null,
	nip: null,
};

export const defaultPersonalInfoErrors: PersonalInfoErrors = {
	email: '',
	firstName: '',
	lastName: '',
	pesel: '',
	phone: '',
	businessName: '',
	nip: '',
};

export const defaultPersonalInfoRAdressErrors: PersonalInfoAdressErrors = {
	appartmentNo: '',
	city: '',
	houseNo: '',
	postalCode: '',
	street: '',
};

export const initialState: State = {
	personalInfo: defaultPersonalInfo,
	personalInfoErrors: defaultPersonalInfoErrors,
	personalInfoRAdressErrors: defaultPersonalInfoRAdressErrors,
	startDate: null,
	consentsStep1: [],
	consentsStep2: [],
	selectedRisksIds: [],
	vereficationCode: '',
	paywallUrl: null,
	loaded: true,
	vereficationCodeError: '',
	formAccessible: false,
	extendedOcCoverageSelected: false,
	formSuccess: false,
	showStage1Error: false,
	showStage2Error: false,
	hasBusiness: false,
};

export const slice = createSlice({
	name: 'ui/form',
	initialState,
	reducers: Seters,
});

export const formReducer = slice.reducer;
const Actions = slice.actions;
export { Actions };

export type PersonalInfoErrors = {
	[K in keyof Omit<IPersonalInfo, 'residentalAddress'>]: string;
};

export type PersonalInfoAdressErrors = {
	[K in keyof IAdress]: string;
};
